import {
  calculatePrestationDebt,
  computePrestationCommiteeAmount,
  type PrestationParticipationWithEmployee,
} from '@cpce/shared';
import type { PrestationParticipationFormatted } from '@/api/prestations/prestations.types';

export function formatPrestationParticipation(
  prestationParticipation: PrestationParticipationWithEmployee
): PrestationParticipationFormatted {
  const employeeId = prestationParticipation.externalEmployeeId ?? 0;
  const beneficiaryId =
    prestationParticipation.participants.find((p) => p.externalBeneficiaryId)
      ?.externalBeneficiaryId ?? employeeId;
  const {
    employeeFirstName,
    employeeLastName,
    employeeStatus,
    employeeMatricule,
    employeeMissingFromTicketing,
  } = prestationParticipation;
  return {
    ...prestationParticipation,
    employee:
      employeeFirstName !== null || employeeLastName !== null
        ? {
            beneficiary: {
              firstName: employeeFirstName,
              lastName: employeeLastName,
            },
            status: employeeStatus,
            matricule: employeeMatricule,
            isMissingFromTicketing: employeeMissingFromTicketing,
          }
        : undefined,
    employeeId,
    beneficiaryId,
    commiteeAmount: computePrestationCommiteeAmount(prestationParticipation),
    remainingDebt: calculatePrestationDebt(prestationParticipation),
    remarks: prestationParticipation.remarks ?? null,
    debtReminders: prestationParticipation.debtReminders.map((dr) => ({
      identifier: dr.identifier,
      communication: dr.communication
        ? { dateTime: new Date(dr.communication.dateTime) }
        : undefined,
    })),
  };
}
